import { render, staticRenderFns } from "./pcfallimg.vue?vue&type=template&id=d13ccf10&scoped=true"
import script from "./pcfallimg.vue?vue&type=script&lang=js"
export * from "./pcfallimg.vue?vue&type=script&lang=js"
import style0 from "./pcfallimg.vue?vue&type=style&index=0&id=d13ccf10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13ccf10",
  null
  
)

export default component.exports